import React, { useMemo, useState } from 'react'
import { NumberConvert } from '../../../common/numberConvert'
import { Toast } from '../../../common/message';
import Axios from 'axios';
import dayjs from 'dayjs';
import { get_point } from '../common/give_point';
import { getRandom } from '../../../common/RandomNumber';

const MainItemModal = ({ data, setModalOpen, point, setUserPoints, userBuyTotal, setUserBuyTotal }) => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  const basicID = window.sessionStorage.getItem('basicID');
  const basicName = window.sessionStorage.getItem('basicName');
  const basicStore = window.sessionStorage.getItem('basicStore');
  
  const [userPoint, setUserPoint] = useState(0);

  const [boxEffect, setBoxEffect] = useState(false);
  const [nextValue, setNextValue] = useState(false);
  const [waitBtn, setWaitBtn] = useState(false);
  const [pointValue, setPointValue] = useState(0);

  // 아이템 판매 처리
  const itemBuy = async () => {

    setUserPoint(prev => prev -= data.price); // 가지고 있던 값에서 포인트 차감
    setUserBuyTotal(prev=>prev + 1); // 구매 토탈 플러스

    await Axios.post(`/api/Point_store/buyitem`, {
      itemIno: data.no, Title: data.title, Count: 1, Price: data.price, Point: pointValue, userId: basicID, Date: toDay.time,
    })
    .then((res)=>{
      itemBuyPointLog(); // 로그 기록
      ItemCountUpdate(); // 구매한 상품 재고 변경
      itemBuyPointValue(); // 상품 개봉으로 인한 포인트 결과
    });
  };

  // 상품 구매 성공시 포인트 로그도 기록
  const itemBuyPointLog = async () => {

    await Axios.post(`/api/UserPointExp/adddata`, {
      Store: basicStore, ID: basicID, Name: basicName,
      Point: `-${data.price}`, P_Bonus: 0, Exp: 0, E_Bonus: 0,
      Location: '포인트상점', Log: `${data.title} 상품 구매`, Date: toDay.time
    })
    .then((res)=>{
      // console.log(`포인트 및 기여도 증감 성공`);
    })
    .catch((err)=>{
      console.log(`포인트와 기여도 증감이 실패했습니다.\n`, err);
    });
  };

  // 상품 개봉에 의한 포인트 변동
  const itemBuyPointValue = async () => {

    await Axios.post(`/api/Point_store/pointvalue`, {
      Store: basicStore, ID: basicID, Name: basicName,
      Point: pointValue, P_Bonus: 0, Exp: 0, E_Bonus: 0,
      Location: '포인트상점', Log: `${data.title} 상품 구매`, Date: toDay.time
    })
    .then((res)=>{
      // console.log(`상품 결과 포인트 및 기여도 증감 성공`);
    })
    .catch((err)=>{
      console.log(`상품 결과 포인트와 기여도 증감이 실패했습니다.\n`, err);
    });
  };

  // 구매 성공시 재고 차감
  const ItemCountUpdate = async ()=>{
    await Axios.put(`/api/Point_store/itemupdate`, {
      itemIno: data.no, Count: 1,
    })
    .then((res)=>{

    })
  };

  // 구매 확정 버튼 클릭시
  const buyBtn = async ()=>{
    
    if(data.count < 1) return Toast.fire({ icon: "error", text: `해당 상품은 전부 판매되었습니다` });

    if(data.price > point){
      setWaitBtn(false);
      return Toast.fire({ icon: "error", text: `포인트가 ${NumberConvert(data.price - userPoint)}P 부족합니다` });
    } else {
      // 포인트 값 차감
      setUserPoints((prev) => prev - data.price);
      // 재고 차감
      data.count -= 1;

      // 당첨된 포인트
      // 아이템 구매
      setWaitBtn(true);

      itemBuy();
    }

    if(data.state !== '정상') return Toast.fire({ icon: "error", text: `${data.title} 상품이 구매할 수 없는 상태입니다.` });

    setBoxEffect(true);

    const timer1 = setTimeout(() => {
      setBoxEffect(false);
      setNextValue(true);

      // 메인에 값 전달
      if(pointValue < 1){
        setUserPoints(prev=>prev - -pointValue);
      } else {
        setUserPoints(prev=>prev + pointValue);
      }

      return ()=>{
        clearTimeout(timer1);
      }
    }, getRandom(1000, 5000));
  }

  // 상품 구매 제한
  const [UserBuyCounts ,setUserBuyCounts] =  useState(0);

  // 사용자 포인트 불러오기
  useMemo(()=>{

    let Mount = true;

    // 초기에 미리 지정
    setPointValue(get_point(data.level, data.price));

    // 특정 상품 당일에 몇 개 구매했는지
    const pointItemBuyCount = async ()=>{
      await Axios.get('/api/Point_store/buycount', {
        params: { itemIno: data.no, userId: basicID, Date: toDay.date}
      })
      .then((res)=>{
        if(Mount){
          setUserBuyCounts(res.data.length ?? 0);
        }
      })
    };
    pointItemBuyCount();

    return ()=>{
      Mount = false;
    }
  }, [])
  
  return (
    <>
    {
      // 해당 상품의 구매 횟수 초과시
      data.buycount > UserBuyCounts ?
      <div className={`flex flex-col gap-3 h-full justify-between tracking-wide text-sm ${boxEffect ? 'animate-pulse' : 'animate-none'}`}>
        
        <div className='flex flex-col gap-3 h-full'>

          {/* 상품 번호, 상태, 재고, 가격 */}
          <div className='grid grid-cols-2 md:grid-cols-4 gap-3'>
            <div className='flex flex-col gap-1 justify-between bg-[#2E2E2E] p-3 rounded-md'>
              <p className='text-stone-400'>상품 번호</p>
              <p className='text-center' style={{fontFamily: 'Gugi'}}>No. {data.no}</p>
            </div>
            <div className='flex flex-col gap-1 justify-between bg-[#2E2E2E] p-3 rounded-md'>
              <p className='text-stone-400'>상품 상태</p>
              <p className='text-center' style={{fontFamily: 'Gugi'}}>
                {
                (data.value === '정상' && `🟢 ${data.value}`) ||
                (data.value === '비정상' && `🟡 ${data.value}`) ||
                (data.value === '위험' && `🟠 ${data.value}`) ||
                (data.value === '고위험' && `🔴 ${data.value}`)
                }
              </p>
            </div>
            <div className='flex flex-col gap-1 justify-between bg-[#2E2E2E] p-3 rounded-md'>
              <p className='text-stone-400'>재고 상황</p>
              <p className='text-center' style={{fontFamily: 'Gugi'}}>
                {
                (data.count < 1 && '🔴 품절') || 
                (data.count <= 5 && '🟠 곧 품절') || 
                (data.count <= 10 && '🟡 적정') ||
                (data.count > 10 && '🟢 원활')
                }
              </p>
            </div>
            <div className='flex flex-col gap-1 justify-between bg-[#2E2E2E] p-3 rounded-md'>
              <p className='text-stone-400'>제품 가격</p>
              <p className='text-center' style={{fontFamily: 'Gugi'}}>💰 {NumberConvert(data.price)} P</p>
            </div>
          </div>

          {/* 제품이름 및 부가설명 */}
          <div className='grid grid-cols-1 md:grid-cols-2 justify-between gap-3'>
            <div className='flex flex-col gap-3 bg-[#2E2E2E] p-3 rounded-md'>
              <p className='text-stone-400'>제품 이름</p>
              <p className='' style={{fontFamily: 'Gugi'}}>{data.title}</p>
            </div>
            <div className='flex flex-col gap-3 bg-[#2E2E2E] p-3 rounded-md'>
              <p className='text-stone-400'>부가 설명</p>
              <p className='' style={{fontFamily: 'Gugi'}}>{data.subtitle ? data.subtitle : '-'}</p>
            </div>
          </div>

          {/* 제품 설명 */}
          <div className='grid grid-cols-1 gap-3 bg-[#2E2E2E] p-3 rounded-md'>
            <p className='text-stone-400'>제품 설명</p>
            <p className='italic'>{data.text}</p>
          </div>

          {/* 최상단 제품 구매 가능 횟수 */}
          <div className='flex gap-3 p-3 bg-[#1E1E1E] rounded-md'>
            <div className='flex justify-between w-full'>
              <div className='flex gap-2 items-center'>
                <p className='font-semibold whitespace-normal text-lg'>🎫</p>
                <p style={{fontFamily: 'Gugi'}} className='whitespace-normal text-[#8E8E8E]'>
                  {`당일 구매 제한 ${UserBuyCounts} / ${data.buycount}회`}
                </p>
              </div>
              <p className='font-semibold whitespace-normal text-[#8E8E8E]'>{`|`}</p>
              <div className='flex gap-2 items-center'>
                {/* <p className='font-semibold whitespace-normal text-lg'>🎫</p> */}
                <p style={{fontFamily: 'Gugi'}} className='whitespace-normal text-[#8E8E8E]'>
                  {`구매 제한은 자정에 초기화됩니다`}
                </p>
              </div>
            </div>
          </div>

          {/* ❗❕❓❔‼️⁉️🟢🟡🟠🔴🔵🟣🟤🎟️♥️🔒🔓🔑🗝️🚬🔋🪫💰📢 */}

          {/* 결과창 */}
          <div className={`flex h-full flex-col bg-[#1E1E1E] rounded-md p-3`}>

            {
              !nextValue ?
              <div className='h-full'>

                <div className='flex flex-col gap-3 justify-center h-full items-center '>
                  {/* <p className={`${boxEffect ? 'animate-ping' : 'animate-none'} text-7xl opacity-90`}>🎁</p> */}
                  <p className={`${boxEffect ? 'animate-ping' : 'animate-none'} text-7xl opacity-80`}>
                    🎁
                  </p>
                  <p className={`${waitBtn && 'hidden'} text-stone-400 animate-pulse text-base`}>
                    두근 두근... 과연 결과가 어떻게 나올까요?
                  </p>
                </div>

              </div>
              :
              <div className='h-full'>
                <div className='flex flex-col h-full justify-between items-center overflow-y-auto overflow-x-hidden'>
                  <p className='text-xl' style={{fontFamily: 'Gugi'}}>
                    {
                      // 🎉🎊
                      pointValue > 0
                      ?
                      <span>
                        {
                          data.price > pointValue
                          ? '🎉 당첨은 되었지만 본전도 건지지 못했어요..'
                          : '🎉 당첨을 축하드립니다, 이득을 봤어요!!'
                        }
                        </span>
                      :
                      <span>💣 이번에는 운이 좋지 않았네요..</span>
                    }
                  </p>
                  <div>
                    <p className={`${pointValue > 0 ? 'animate-bounce text-yellow-400' : 'animate-pulse text-red-400'} text-2xl`} style={{fontFamily: 'Gugi'}}>
                      {NumberConvert(pointValue - data.price)} P
                    </p>
                  </div>

                  <div className='flex flex-col justify-center items-center pt-2 gap-3 border-t-[1px] border-[#4E4E4E] w-full'>

                    <div className='flex gap-2 text-stone-400 italic'>
                      <p>{NumberConvert(pointValue)}P (당첨)</p>
                      <p>-</p>
                      <p>{NumberConvert(data.price)}P (상품 가격)</p>
                      <p>=</p>
                      <p>{NumberConvert(pointValue - data.price)}P</p>
                    </div>

                  </div>

                </div>
              </div>
            }          

          </div>

        </div>

        {/* 마지막 그리드 */}
        <div className={`${data.count > 0 ? 'inline' : 'hidden'}`}>
          {
            waitBtn ?
            null
            :
            <button className='w-full p-2 flex gap-2 justify-center rounded-sm bg-blue-500 duration-100 hover:opacity-90 active:opacity-70 text-base'
            style={{fontFamily: 'Gugi'}} onClick={()=>{
              buyBtn();
            }}>
            <p>{`-${NumberConvert(data.price)} P`}</p>
            <p>{`구매 확정`}</p>
          </button>
          }
        </div>

      </div>
      :
      <div className='flex flex-col h-full justify-between tracking-wide'>
      {/* 🎫🎟️ */}
        <div className='flex flex-col justify-center items-center h-full'>
          <div className='flex flex-col gap-3 bg-[#2E2E2E] text-center whitespace-normal p-3 rounded-md'>
            <p className='text-5xl'>🎫</p>
            <p>오늘은 더 이상 구매하실 수 없습니다</p>
            <p>구매 횟수를 모두 사용하셨습니다</p>
            <p>{data.title}의 하루 구매 횟수는 {data.buycount}회 입니다</p>
          </div>
        </div>

      </div>
    }
    </>
  )
}

export default MainItemModal